import {
  hm5GlobalReleaseConstants,
  addHM5GlobalReleaseConstants,
  editHM5GlobalReleaseConstants,
} from "../_redux-constants";
import { hm5GlobalReleaseService } from "../../_services";

function getHM5GlobalRelease() {
  function getHM5GlobalReleaseLoad() {
    return { type: hm5GlobalReleaseConstants.HM5_GLOBAL_RELEASE_LOADING };
  }
  function getHM5GlobalReleaseSuccess(data) {
    return {
      type: hm5GlobalReleaseConstants.HM5_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function getHM5GlobalReleaseFailure(error) {
    return {
      type: hm5GlobalReleaseConstants.HM5_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHM5GlobalReleaseLoad());
    return hm5GlobalReleaseService.getHM5GlobalRelease().then(
      (data) => {
        dispatch(getHM5GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(getHM5GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addHM5GlobalRelease(formData) {
  function addHM5GlobalReleaseLoad() {
    return {
      type: addHM5GlobalReleaseConstants.ADD_HM5_GLOBAL_RELEASE_LOADING,
    };
  }
  function addHM5GlobalReleaseSuccess(data) {
    return {
      type: addHM5GlobalReleaseConstants.ADD_HM5_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function addHM5GlobalReleaseFailure(error) {
    return {
      type: addHM5GlobalReleaseConstants.ADD_HM5_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addHM5GlobalReleaseLoad());
    return hm5GlobalReleaseService.addHM5GlobalRelease(formData).then(
      (data) => {
        dispatch(addHM5GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addHM5GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editHM5GlobalRelease(formData) {
  function editHM5GlobalReleaseLoad() {
    return {
      type: editHM5GlobalReleaseConstants.EDIT_HM5_GLOBAL_RELEASE_LOADING,
    };
  }
  function editHM5GlobalReleaseSuccess(data) {
    return {
      type: editHM5GlobalReleaseConstants.EDIT_HM5_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editHM5GlobalReleaseFailure(error) {
    return {
      type: editHM5GlobalReleaseConstants.EDIT_HM5_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editHM5GlobalReleaseLoad());
    return hm5GlobalReleaseService.editHM5GlobalRelease(formData).then(
      (data) => {
        dispatch(editHM5GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editHM5GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const hm5GlobalReleaseActions = {
  getHM5GlobalRelease,
  addHM5GlobalRelease,
  editHM5GlobalRelease,
};
